import { parsePhoneNumberFromString } from "libphonenumber-js";

export const parsePhoneNumberAttributes = (fullMdn?: string): { countryCallingCode?: string; customerMdn?: string } => {
    if (!fullMdn) {
        return { countryCallingCode: undefined, customerMdn: undefined };
    }

    const parsed = parsePhoneNumberFromString(fullMdn);
    if (!parsed) {
        return { countryCallingCode: undefined, customerMdn: undefined };
    }

    return {
        countryCallingCode: `+${parsed.countryCallingCode}`,
        customerMdn: parsed.nationalNumber,
    };
};
